export const RUNNING_STATUS = ['queued', 'starting', 'running', 'postprocess'];
